// @ts-nocheck 5f80f532
import * as addPanel from '#packages/oldAddPanel';

export default {
  getDesignSections() {
    return {
      titles: ['design_section_label_explore_textarea'],
      sections: [addPanel.sections.getSections().developer.textAreaSection],
    };
  },
};
